import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { rootRoute } from '../../../router/routes/rootRoute';

export const fipCallbackRoute = createRoute({
	path: '/fip-callback',
	getParentRoute: () => rootRoute,
	validateSearch: z.object({
		sessionId: z.string().optional(),
	}),
	component: lazyRouteComponent(
		() => import('./FipCallbackPage'),
		'FipCallbackPage',
	),
	staticData: {
		disableAuthGuard: true,
	},
});
